import request from '@/utils/request';

export function getCarouselList(params) {
  return request({
    url: '/gateway/carousel/list',
    method: 'get',
    params
  });
}

export function getCompanyProfile() {
  return request({
    url: '/home/CompanyProfile',
    method: 'get'
  });
}